



































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router/types/router';

import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import {
  PaymentReportViewModel,
  VantivRefundViewModel,
} from '@/models/payment/paymentreport';
import {
  PaymentDetailViewModel,
  PaymentDetailResponseViewModel,
} from '@/models/fixedops/repairorder';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import {
  getArPaymentResponseHeaders,
  getCustomerChargeTransactionHeaders,
  getPaymentAccountListHeaders,
  getPaymentResponseHeaders,
} from '@/views/payment/payment';

import {
  userService,
  paymentReportService,
  repairOrderService,
  storeService,
  paymentService,
} from '@/shared';
import { PaymentDetailDataViewModel } from '@/Alynk.dtos';
import { mapGetters } from 'vuex';
import { RoleType } from '@/helper/enum';
import { Utils } from '@/helper/utils';
import { NotificationType } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    ...mapGetters({ currentRoles: 'getRoles' }),
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    Calendar: () => import('@/components/common/app.calendar.vue'),
  },
})
export default class ARPaymentReportPage extends Base {
  public headers: VHeaders[] = getPaymentAccountListHeaders(this);
  public paymentResponseHeaders: VHeaders[] = getArPaymentResponseHeaders(this);
  public customerChargeTransactionHeaders: VHeaders[] = getCustomerChargeTransactionHeaders(
    this
  );
  public paymentReport: any = {
    totalAmountCollected: 0,
    totalAmountDue: 0,
  };
  public pagedPayment: PaymentDetailViewModel[] = [];
  public pagedPaymentResponse: PaymentDetailResponseViewModel[] = [];
  public userList: any[] = [];
  public refundPreset: any[] = [];
  public identifier: string = 'AR';
  public accountNumber: any = '';
  public hideAccountNumber: boolean = false;
  public loading: boolean = false;


  public statusList: any[] = [];
  public pagination = new PaginationModel('date', true);
  public actions: any[] = [];
  public subActions: any[] = [];
  public selectedItem: PaymentDetailViewModel;
  public paymentProvider: string = '';
  public refund: VantivRefundViewModel = {};
  public paymentToRefund: PaymentDetailViewModel = null;

  public params: any = {
    selecteduser: '',
    paymentstatus: '',
    startDate: '',
    endDate: '',
    selectedAccountNumber: ''
  };
  public constants: any = {
    tenantId: '',
    enterpriseId: '',
    storeId: '',
    minDate: '',
  };
  public flags: any = {
    showForm: false,
    showAttachmentDetails: false,
    showEmailPopup: false,
    loading: false,
    invalidUrl: false,
  };

  public showTransactionPopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t('arPaymentReport.titleChargeCustomer') as string,
    model: false,
  };

  public showRefundPopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t('arPaymentReport.refundDialog.title') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('arPaymentReport.refundDialog.btnSubmit') as string,
      disable: false,
    },
    onAction: (): void => {
      this.confirmRefund();
    },
    onClose: (): void => {
      this.clear();
    }
  };

  public clear() {
    this.refundPreset = [];
    this.accountNumber = '';
    this.params.selectedAccountNumber = '';
    this.getRefundPreset();
    this.getAccountNumber();
  }

  public confirmRefundDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('dialogSettings.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('dialogSettings.btntxtAgree') as string,
      disable: false,
    },
    onAction: (): void => {
      this.processRefund();
    },
  };

  public showDmsRetryPopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t('arPaymentReport.titleRetryDmsCall') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-paper-plane',
      text: this.$parent.$t('arPaymentReport.retryDmsCall') as string,
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.retryDmsPost();
    },
  };

  public selectedPayment: PaymentDetailViewModel = null;
  public userLoading: boolean = false;
  public currentRoles: string[];
  public isRefundAllowed: boolean = false;
  public retryDmsTxId: string = '';
  public retryDmsPaymentDetailId: string = '';
  public retryDmsPostStoreId: number = 0;

  public async retryDmsPost(): Promise<void> {
    this.showDmsRetryPopup.loading = true;
    try {
      const postStatus = await paymentReportService.retryArDmsPost(
        this.selectedPayment.transactionHeaderId,
        this.constants.tenantId,
        this.constants.enterpriseId,
        this.constants.storeId
      );
      this.showDmsRetryPopup.loading = false;
      if (postStatus.isSuccess) {
        this.showDmsRetryPopup.model = false;
        this.showAlert(true, 'Data posted to DMS successfully');
        await this.getPayments();
      }
    } catch {
      this.showDmsRetryPopup.loading = false;
    }
  }

  public setSubActions() {
    this.subActions = [
      {
        type: 'button',
        icon: 'fas fa-retweet',
        title: 'Retry Dms Post',
        visible: (model: any) => {
          if (model.status === 'Approved') {
            if ((model.approvedAmount > 0 && model.glStatus == false) || (model.approvedAmount < 0 && model.refundGlStatus == false))
              return true;
            else
              return false;
          } else {
            return false;
          }
        },
        action: (model: PaymentDetailResponseViewModel) => {
          this.showRetryDmsPost(model);
          return ``;
        },
      },
      {
        type: 'button',
        icon: 'fas fa-eye',
        title: 'View Receipt',
        color: 'primary',
        visible: (model: any) => {
          if (model.status === 'Approved') {
            return true;
          } else {
            return false;
          }
        },
        action: (model: any) => {
          this.downloadReceipt(model);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-undo-alt',
        title: this.$parent.$t(
          'arPaymentReport.arPaymentReportGrid.actionGrid.refund'
        ) as string,
        disable: (model: PaymentDetailResponseViewModel) => {
          if (
            (model.status !== 'Approved' &&
              model.status !== 'PartialApproved') ||
            model.approvedAmount < 0
          ) {
            return true;
          }
          return false;
        },
        action: (model: PaymentDetailResponseViewModel) => {
          this.showRefund(model);
          return ``;
        },
      },

    ];
  }

  public showRefund(payment: PaymentDetailViewModel): void {
    this.paymentToRefund = payment;
    this.refund.transactionAmount = '';
    this.showRefundPopup.model = true;
    this.getAccountNumber();
  }


  public created(): void {
    // this.paymentReportService = new PaymentReportService();
    // this.userService = new UserService();
    this.params.startDate = this.subtractDaysFromPresent(30);
    this.params.endDate = this.presentDate();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'search') {
      this.searchPayments();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    // let buttons: any = [];
    // buttons.push({'id':'0', 'type':'button', 'title':'Search', 'disabled':false, 'visible': true, 'class':'btn', 'label':'Search', 'click':'search', 'icon':'fas fa-search', 'requestProgress': true});
    // this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'arPaymentReport');

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (!this.flags.invalidUrl) {
      this.getStatus();
      this.addWatchers();
      if (this.$route.query.startDate && this.$route.query.endDate) {
        this.params.startDate = this.$route.query.startDate.toString();
        this.params.endDate = this.$route.query.endDate.toString();
      }
      const pagination = Utils.getPaginationFromRouteQuery(this.$route.query);
      if (pagination) {
        this.pagination = pagination;
      }
      this.getDefaultPaymentType();
      this.getPayments();
      this.getUsers();
    }
    this.getRefundPreset();
    this.setActions();
    this.setSubActions();
    const roles = this.currentRoles;
    if (roles.indexOf(RoleType.AllowRefund) > -1) {
      this.isRefundAllowed = true;
    }
  }

  public addWatchers(): void {
    this.$watch('$route', (newVal, oldVal) => {
      this.params.startDate =
        newVal.query.startDate || this.presentDate();
      this.params.endDate =
        newVal.query.endDate || this.presentDate();
      this.params.selecteduser = newVal.query.selecteduser || '';
      this.params.paymentstatus = newVal.query.paymentstatus || '';
      this.getPayments();
    });
    this.$watch('flags.showRefundPopup', (newVal, oldVal) => {
      if (!newVal) {
        return;
      }
      requestAnimationFrame(() => {
        this.$refs.refundAmount['focus']();
      });
    });
  }
  public updatePaging(paging: any) {
    this.pagination = paging;
  }
  public updateFlag(flag, value): void {
    this.flags[flag] = value;
  }
  public async getStatus(): Promise<void> {
    const response = await paymentReportService.getPaymentstatusList();
    this.statusList = response.results;
    this.statusList.unshift({
      id: '',
      text: this.$parent.$t('arPaymentReport.select'),
    });
  }
  public searchPayments(): void {
    const queryStringObj = Object.assign({}, this.pagination) as any;
    if (queryStringObj) {
      queryStringObj.startDate = this.params.startDate;
      queryStringObj.endDate = this.params.endDate;
    }
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getPayments();
  }
  public setActions() {
    this.actions = [
      // {
      //   type: 'button',
      //   icon: 'fas fa-retweet',
      //   title: this.$parent.$t('arPaymentReport.action.dmsRetry') as string,
      //   disable: (model: PaymentDetailDataViewModel) => {
      //     if (
      //       model.chargeCustomerTransactions &&
      //       model.chargeCustomerTransactions.length > 0 &&
      //       model.glStatus == 'False'
      //     ) {
      //       return false;
      //     }
      //     return true;
      //   },
      //   visible: (model: PaymentDetailDataViewModel) => {
      //     return true;
      //   },
      //   action: (model: PaymentDetailDataViewModel) => {
      //     this.selectedPayment = model;
      //     this.refund.transactionAmount = '';
      //     this.showDmsRetryPopup.model = true;
      //     return ``;
      //   },
      // },
      {
        type: 'button',
        icon: 'fas fa-info',
        title: this.$parent.$t(
          'arPaymentReport.action.chargeCustomerTransactions'
        ) as string,
        disable: (model: PaymentDetailViewModel) => {
          if (
            model.chargeCustomerTransactions &&
            model.chargeCustomerTransactions.length > 0
          ) {
            return false;
          }
          return true;
        },
        visible: (model: PaymentDetailViewModel) => {
          return true;
        },
        action: (model: PaymentDetailViewModel) => {
          this.showTransactions(model);
          return ``;
        },
      },
    ];
  }

  public showTransactions(payment: PaymentDetailViewModel): void {
    this.selectedPayment = payment;
    this.refund.transactionAmount = '';
    this.showTransactionPopup.model = true;
  }
  public async getPayments(): Promise<void> {
    try {
      this.flags.loading = true;
      this.$emit('update:progress', this.flags.loading);
      const report = await paymentReportService.reportReceivable(
        this.params.selecteduser,
        this.params.paymentstatus,
        this.params.startDate,
        this.params.endDate
      );
      this.paymentReport = report;
      this.pagedPayment = this.paymentReport.payments;
      this.pagination.totalItems = this.paymentReport.payments.length;
    } finally {
      this.flags.loading = false;
      this.$emit('update:progress', this.flags.loading);
    }
  }
  public getPaymentResponse(
    payment: PaymentDetailViewModel
  ): PaymentDetailResponseViewModel[] {
    this.pagedPaymentResponse = payment.paymentResponses;
    const result = payment.paymentResponses.map((item) => {
      (item.transactionHeaderId = payment.transactionHeaderId),
        (item.laneId = payment.laneId),
        (item.storeId = payment.storeId);
      return item;
    });
    return result; //   payment.paymentResponses;
  }
  public updateUser(val): void {
    this.params.selecteduser = val;
  }
  public async getUsers(): Promise<void> {
    try {
      this.userLoading = true;
      const users = await userService.getStoreUsersListAsync();
      this.userList = users.results;
      this.userList.unshift({
        id: '',
        text: this.$parent.$t('arPaymentReport.selectAll'),
      });
    } finally {
      this.userLoading = false;
    }
  }

  public async getRefundPreset(): Promise<void> {
    try {
      const refundPresets = await storeService.getRefundPresst(this.identifier);
      this.refundPreset = refundPresets;
    } finally {
    }
  }

  public getAccountNumber() {
    try {
      this.loading = true;
      if (this.params.selectedAccountNumber == '') {
        this.hideAccountNumber = false;
      } else {
        this.hideAccountNumber = true;
      }
      const account = this.refundPreset.filter(
        (item) => item.id == this.params.selectedAccountNumber
      );
      this.accountNumber = account.length > 0 ? account[0].accountNumber : '';
    } finally {
      this.loading = false;
    }
  }

  public confirmRefund(): void {
    if (Number(this.refund.transactionAmount) <= 0) {
      this.showAlert(false, 'Amount can not be 0');
      return;
    }

    if (this.refund.transactionAmount > this.paymentToRefund.approvedAmount) {
      this.showAlert(
        false,
        'Refund Amount Can not be greater than Paid Amount , Or please Refresh if you have already processed refund'
      );
      return;
    }

    if (this.params.selectedAccountNumber == '' || this.params.selectedAccountNumber == undefined) {
      this.showAlert(false, 'Please Select Preset Account to Refund.');
      return;
    }

    var accountDetails = this.refundPreset.filter(
      (x) => x.id == this.params.selectedAccountNumber
    )[0];
    if (
      accountDetails != null &&
      accountDetails != undefined &&
      !accountDetails.isDmsPostAllowed
    ) {
      this.showAlert(
        false,
        'As per selected configuration debit and credit Account/Control details are same , So Transaction is not allowed.'
      );
      return;
    }

    this.confirmRefundDialog.model = true;
  }

  public async processRefund(): Promise<void> {
    try {
      this.showRefundPopup.action.disable = true;
      this.confirmRefundDialog.action.disable = true;
      if (this.isRefundAllowed) {
        const refund = await paymentReportService.processRefund(this);
        if (refund.data === 'success') {
          this.flags.showRefundPopup = false;
          this.showAlert(true, refund.statusMessage);
          this.accountNumber = '';
          this.params.selectedAccountNumber = '';
          this.getPayments();
        }
      } else {
        this.showAlert(
          false,
          'You are not allowed refund, Please contact Admin'
        );
      }
    } finally {
      this.showRefundPopup.action.disable = false;
      this.confirmRefundDialog.action.disable = false;
      this.showRefundPopup.model = false;
      this.confirmRefundDialog.model = false;
    }
  }

  public setParmdates(dates: any) {
    if (dates.length > 1) {
      this.params.startDate = dates[0];
      this.params.endDate = dates[1];
    }
  }

  public async getDefaultPaymentType(): Promise<void> {
    try {
      const result = await repairOrderService.getDefaultPaymentProvider();
      this.paymentProvider = result.paymentProvider;
    } finally {
      // finally block
    }
  }

  public async downloadReceipt(request): Promise<void> {
    try {
      const response = await paymentReportService.downloadReceipt(
        request.transactionHeaderId,
        request.transactionId,
        request.paymentType
      );

      if (response?.fileDownloadName) {
        window.open(response.fileDownloadName, '_blank');
      } else {
        this.showNotification(NotificationType.Warning, "Receipt is not available for this transaction.");
      }
    } finally {
      // finally block
    }
  }

  public showRetryDmsPost(payment: PaymentDetailViewModel): void {
    //this.paymentToRetryDmsPost = payment;
    // this.refund.transactionAmount = '';
    this.retryDmsTxId = payment.transactionHeaderId;
    this.retryDmsPaymentDetailId = payment.id;
    this.retryDmsPostStoreId = payment.storeId;
    this.glRetryDialogPopup.model = true;
  }

  public glRetryDialogPopup: IDialogOption = {
    width: 400,
    title: this.$parent.$t('dialogSettings.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('dialogSettings.btntxtAgree') as string,
    },
    onAction: (): void => {
      this.retryGlPost();
    },
  };

  public async retryGlPost() {
    try {
      this.glRetryDialogPopup.loading = true;

      var res = await paymentService.retryPaymentGlPost(
        'deal',
        this.retryDmsTxId,
        this.retryDmsPaymentDetailId,
        '',
      );

      if (res.isSuccess) {
        this.showAlert(true, 'Gl Data Posted Successfully');
        this.getPayments();
      } else {
        this.showAlert(false, 'Failed to post Gl data');
      }
    }
    finally {
      this.glRetryDialogPopup.model = false;
      this.glRetryDialogPopup.loading = false;
      this.retryDmsTxId = '';
      this.retryDmsPaymentDetailId = '';
    }
  }

  public blockMoreThanTwoDecimals(e: KeyboardEvent): void {
  const input = e.target as HTMLInputElement;
  const value = input.value;
  const key = e.key;

  // allow control keys
  if (
    key === 'Backspace' ||
    key === 'Delete' ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight' ||
    key === 'Tab'
  ) {
    return;
  }

  // allow only digits and decimal
  if (!/[\d.]/.test(key)) {
    e.preventDefault();
    return;
  }

  // block second decimal point
  if (key === '.' && value.includes('.')) {
    e.preventDefault();
    return;
  }

  // block more than 2 digits after decimal
  const decimalIndex = value.indexOf('.');
  if (decimalIndex !== -1) {
    const decimals = value.substring(decimalIndex + 1);
    if (decimals.length >= 2) {
      e.preventDefault();
    }
  }
}
}
